// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-boundary-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background:
    radial-gradient(circle at top, rgba(239, 68, 68, 0.12), transparent 38%),
    linear-gradient(180deg, rgba(10, 10, 10, 0.98), rgba(10, 10, 10, 1));
}

.error-boundary-card {
  width: min(720px, 100%);
  padding: 28px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(22, 33, 62, 0.72);
  backdrop-filter: blur(18px);
  box-shadow:
    0 24px 60px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
  color: #f8fafc;
}

.error-boundary-card--chunk {
  border-color: rgba(239, 68, 68, 0.28);
  box-shadow:
    0 24px 60px rgba(0, 0, 0, 0.45),
    0 0 0 1px rgba(239, 68, 68, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.error-boundary-eyebrow {
  margin-bottom: 10px;
  color: #fca5a5;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.error-boundary-title {
  margin: 0 0 12px;
  font-size: clamp(1.5rem, 1.1rem + 1vw, 2rem);
  line-height: 1.1;
  color: #ffffff;
}

.error-boundary-message {
  margin: 0 0 20px;
  color: rgba(226, 232, 240, 0.82);
  font-size: 0.98rem;
  line-height: 1.6;
}

.error-boundary-details {
  max-height: min(36vh, 320px);
  overflow: auto;
  padding: 16px;
  margin-bottom: 20px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(10, 10, 10, 0.72);
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 0.8rem;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
}

.error-boundary-error {
  display: block;
  color: #fecaca;
}

.error-boundary-stack {
  margin-top: 10px;
  color: rgba(148, 163, 184, 0.92);
}

.error-boundary-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.error-boundary-button {
  min-height: 44px;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: background 150ms ease, border-color 150ms ease, transform 150ms ease, color 150ms ease;
}

.error-boundary-button:hover {
  transform: translateY(-1px);
}

.error-boundary-button--primary {
  background: linear-gradient(135deg, #ef4444, #f97316);
  color: #fff;
  box-shadow: 0 12px 24px rgba(239, 68, 68, 0.22);
}

.error-boundary-button--primary:hover {
  background: linear-gradient(135deg, #f87171, #fb923c);
}

.error-boundary-button--secondary {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
  color: #e2e8f0;
}

.error-boundary-button--secondary.is-copied {
  background: rgba(34, 197, 94, 0.18);
  border-color: rgba(34, 197, 94, 0.3);
  color: #bbf7d0;
}

.error-boundary-button--ghost {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.12);
  color: rgba(226, 232, 240, 0.88);
}

.error-boundary-button--ghost:hover,
.error-boundary-button--secondary:hover {
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 768px) {
  .error-boundary-shell {
    min-height: calc(100vh - 96px);
    padding: 20px 14px;
  }

  .error-boundary-card {
    padding: 20px;
    border-radius: 20px;
  }

  .error-boundary-details {
    max-height: 42vh;
  }

  .error-boundary-actions {
    flex-direction: column;
  }

  .error-boundary-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ErrorBoundary.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;wEAEsE;AACxE;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kCAAkC;EAClC,2BAA2B;EAC3B;;2CAEyC;EACzC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC;;;2CAGyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,4EAA4E;EAC5E,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".error-boundary-shell {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 20px;\n  background:\n    radial-gradient(circle at top, rgba(239, 68, 68, 0.12), transparent 38%),\n    linear-gradient(180deg, rgba(10, 10, 10, 0.98), rgba(10, 10, 10, 1));\n}\n\n.error-boundary-card {\n  width: min(720px, 100%);\n  padding: 28px;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(22, 33, 62, 0.72);\n  backdrop-filter: blur(18px);\n  box-shadow:\n    0 24px 60px rgba(0, 0, 0, 0.45),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  color: #f8fafc;\n}\n\n.error-boundary-card--chunk {\n  border-color: rgba(239, 68, 68, 0.28);\n  box-shadow:\n    0 24px 60px rgba(0, 0, 0, 0.45),\n    0 0 0 1px rgba(239, 68, 68, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.error-boundary-eyebrow {\n  margin-bottom: 10px;\n  color: #fca5a5;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.error-boundary-title {\n  margin: 0 0 12px;\n  font-size: clamp(1.5rem, 1.1rem + 1vw, 2rem);\n  line-height: 1.1;\n  color: #ffffff;\n}\n\n.error-boundary-message {\n  margin: 0 0 20px;\n  color: rgba(226, 232, 240, 0.82);\n  font-size: 0.98rem;\n  line-height: 1.6;\n}\n\n.error-boundary-details {\n  max-height: min(36vh, 320px);\n  overflow: auto;\n  padding: 16px;\n  margin-bottom: 20px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(10, 10, 10, 0.72);\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 0.8rem;\n  line-height: 1.55;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.error-boundary-error {\n  display: block;\n  color: #fecaca;\n}\n\n.error-boundary-stack {\n  margin-top: 10px;\n  color: rgba(148, 163, 184, 0.92);\n}\n\n.error-boundary-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.error-boundary-button {\n  min-height: 44px;\n  padding: 0 16px;\n  border-radius: 12px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n  transition: background 150ms ease, border-color 150ms ease, transform 150ms ease, color 150ms ease;\n}\n\n.error-boundary-button:hover {\n  transform: translateY(-1px);\n}\n\n.error-boundary-button--primary {\n  background: linear-gradient(135deg, #ef4444, #f97316);\n  color: #fff;\n  box-shadow: 0 12px 24px rgba(239, 68, 68, 0.22);\n}\n\n.error-boundary-button--primary:hover {\n  background: linear-gradient(135deg, #f87171, #fb923c);\n}\n\n.error-boundary-button--secondary {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.12);\n  color: #e2e8f0;\n}\n\n.error-boundary-button--secondary.is-copied {\n  background: rgba(34, 197, 94, 0.18);\n  border-color: rgba(34, 197, 94, 0.3);\n  color: #bbf7d0;\n}\n\n.error-boundary-button--ghost {\n  background: transparent;\n  border-color: rgba(255, 255, 255, 0.12);\n  color: rgba(226, 232, 240, 0.88);\n}\n\n.error-boundary-button--ghost:hover,\n.error-boundary-button--secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n@media (max-width: 768px) {\n  .error-boundary-shell {\n    min-height: calc(100vh - 96px);\n    padding: 20px 14px;\n  }\n\n  .error-boundary-card {\n    padding: 20px;\n    border-radius: 20px;\n  }\n\n  .error-boundary-details {\n    max-height: 42vh;\n  }\n\n  .error-boundary-actions {\n    flex-direction: column;\n  }\n\n  .error-boundary-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
